import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import UserService from "../services/user.service";
import CatalogService from "../services/catalog.service";
import Carousel from "react-bootstrap/Carousel";
import Card from "react-bootstrap/Card";
import Spinner from "react-bootstrap/Spinner";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";

import ButtonGroup from "react-bootstrap/ButtonGroup";
import { selectCatalogItem, getCatalogItem, selectDecorations, selectInventory } from '../reducers/catalog';
import { addItemToOrder, cartCount, toggleShowCart, cart, updateItemQuantity } from '../reducers/cart';
import { isLoggedIn } from '../reducers/auth';
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { Container, Row, Col, ResponsiveEmbed } from 'react-bootstrap';

const ProductDetails = () => {
  const apiUrl = process.env.REACT_APP_LOCALHOST_URL;
  const { productId } = useParams();
  const dispatch = useDispatch();
  const catalogItem = useSelector(selectCatalogItem);
  const inventory = useSelector(selectInventory);
  const cartCountValue = useSelector(cartCount);
  const itemStatus = useSelector(state => state.catalog.itemStatus)
  const [imgSrc, setImgSrc] = useState(null);
  const [logoSrc, setLogoSrc] = useState("");
  const [imgSrcBack, setImgSrcBack] = useState(null);
  const [currentItem, setCurrentItem] = useState(null);
  const [currentColor, setCurrentColor] = useState(null);
  const [currentImages, setCurrentImages] = useState(null);
  const [currentImage, setCurrentImage] = useState(null);
  const [currentSize, setCurrentSize] = useState(null);
  const [currentPrice, setCurrentPrice] = useState(null);
  const [currentLogoPrice, setCurrentLogoPrice] = useState(null);
  const [currentLogos, setCurrentLogos] = useState(null);
  const [logoBGColor, setLogoBGColor] = useState("#CCCCCC");
  const [logoType, setLogoType] = useState(null);

  const [selectedLogos, setSelectedLogos] = useState([]);
  const [logosByPosition, setLogosByPosition] = useState([]);

  const location = useLocation();
  const loginStatus = useSelector(isLoggedIn);
  let navigate = useNavigate();
  const cartItems = useSelector(cart);

  let qty = 1;
  let selectedColor = location.state.colorId;
  let darkBG = "#333333";
  let lightBG = "#CCCCCC";


  const qtyChanged = (event) => {
    qty = parseInt(event.target.value);
  }
  const gotoLogin = () => {
    navigate("/login");
  }

  const updateLogosByPostion = (logos) => {
    if (!logos || logos.length == 0) {
      setSelectedLogos([]);
      setLogosByPosition([]);
      setCurrentLogoPrice(0);
      setLogoType("none");
      return;
    }

    var newLogosByPosition = [];
    var currentPos = -1;
    var currentPosLogos = [];
    var newSelectedLogos = [];
    var currIdx = -1;
    var first = false;
    for (var i = 0; i < logos.length; i++) {
      if (logos[i].locId !== currentPos) {
        currIdx++;
        newLogosByPosition[currIdx] = [];
        first = true;
        currentPos = logos[i].locId;
      }
      newLogosByPosition[currIdx].push(logos[i]);
      if (first) {
        newSelectedLogos.push(logos[i]);
        first = false;
      }
    }

    setSelectedLogos(newSelectedLogos);
    setLogosByPosition(newLogosByPosition);

    var logoPrice = 0;
    for (var i = 0; i < newSelectedLogos.length; i++) {
      logoPrice += newSelectedLogos[i].price;
    }
    setCurrentLogoPrice(logoPrice);
    console.log("LOGO FOR TYPE", newSelectedLogos[0]);
    setLogoType(newSelectedLogos[0].type);
  }

  const colorImageClick = async (item) => {
    console.log("COLOR CLICKED", item);
    setImgSrc(item.frontModelImage);
    setImgSrcBack(item.backModelImage);
    setCurrentItem(item);
    setCurrentColor(item.colorName);
    setCurrentSize(0);
    var currLogos = [];
    var addedLocs = [];
    var found = false;

    loadImages(item.productId);
    if (item.light == null || !item.light) {
      setLogoBGColor(darkBG);
    } else {
      setLogoBGColor(lightBG);
    }
  }

  const loadImages = async (productId) => {
    let images = await CatalogService.getImagesForProduct(productId);
    setCurrentImages(images.images);
    if(images && images.images && images.images.length > 0) {
      setCurrentImage(images.images[0]);
      updateLogosByPostion(images.images[0].logos);
    } else {
      setCurrentImage(null);
      updateLogosByPostion([]);
    }
  }

  const colorImageOver = (item) => {
    setImgSrc(item.frontModelImage);

    if (item.logos) {
      setLogoSrc(JSON.parse(item.logos)[0][0]);
    }
    setCurrentColor(item.colorName);
  }

  const colorImageExit = (item) => {
    setImgSrc(currentItem.frontModelImage);
    if (currentItem.logos) setLogoSrc(JSON.parse(currentItem.logos)[0][0]);
    setCurrentColor(currentItem.colorName);
  }

  const sizeClick = (sizeId) => {
    setCurrentSize(sizeId);
  }

  const addSameItem = (item, qty) => {
    let args = { item: item, quantity: qty };
    dispatch(updateItemQuantity(args));
  }

  const addToCartButtonClicked = () => {
    if (!loginStatus) return;

    if (!currentSize) {
      alert("Please select a size");
      return;
    }

    let currentProduct = null;
    var i = 0;
    for (i = 0; i < currentItem.sizes.length; i++) {
      if (currentItem.sizes[i].sizeId === currentSize) {
        currentProduct = currentItem.sizes[i].productId;
        break;
      }
    }

    var found = false;
    var added = false;
    for (var j = 0; j < cartItems.length; j++) {
      console.log("LOOKING FOR DUPS", cartItems[j], currentItem.sizes[i]);
      if (cartItems[j].product.id === currentItem.sizes[i].productId) {
        // check for decorations
        var sameDecorations = true;
        for (var k = 0; k < selectedLogos.length; k++) {
          var found = false;
          for (var l = 0; l < cartItems[j].decorations.length; l++) {
            console.log("DECO IDS", cartItems[j].decorations[l], selectedLogos[k].subsiteDecorationId);
            if (cartItems[j].decorations[l].subsiteDecorationId === selectedLogos[k].subsiteDecorationId) {
              found = true;
              break;
            }
          }
          if (!found) {
            sameDecorations = false;
            break;
          }
        }
        if (sameDecorations) {
          console.log("ADD SAME DECO", selectedLogos);
          addSameItem(cartItems[j], cartItems[j].quantity + qty);
          added = true;
        } else {
          console.log("ADD DIFFERENT DECO", selectedLogos);
          dispatch(addItemToOrder({ item: currentItem, quantity: qty, sizeIdx: i, decorations: selectedLogos }));
          added = true;
        }
      }
    }
    // add i fcart is empty
    if (!added) {
      console.log("ADD NEW", selectedLogos);
      dispatch(addItemToOrder({ item: currentItem, quantity: qty, sizeIdx: i, decorations: selectedLogos }));
    }

    dispatch(toggleShowCart(true));
  }

  const galleryImageClicked = async (image) => {
    setCurrentImage(image);
    setImgSrc(image.imageUrl);

    for(var i=0; i<currentImages.length; i++) {
      if(currentImages[i].imageUrl === image.imageUrl) {
        await updateLogosByPostion(currentImages[i].logos);
        break;
      }
    }

  }

  const isSelecedLogo = (logo) => {
    for (var i = 0; i < selectedLogos.length; i++) {
      if (logo.subsiteDecorationId === selectedLogos[i].subsiteDecorationId) {
        return true;
      }
    }

    return false;
  }

  const decoClicked = (logo) => {
    console.log("DECO CLICKED", logo);

    var newSelectedLogos = [];
    for (var i = 0; i < selectedLogos.length; i++) {
      if (selectedLogos[i].locId === logo.locId) {
        newSelectedLogos[i] = logo;
      } else {
        newSelectedLogos[i] = selectedLogos[i];
      }
    }

    setSelectedLogos(newSelectedLogos);
  }
  
  const formatPantsSize = (sizeName) => {
    var isFour =  /^\d{4}$/.test(sizeName);
    if(isFour) {
      return sizeName.substring(0,2) + "x" + sizeName.substring(2);
    } else {
      return sizeName;
    }
  }
  

  useEffect(() => {
    loadImages(productId);

    dispatch(getCatalogItem(productId));
  }, [location.key]);


  useEffect(() => {
    if (itemStatus === 'idle') {
      dispatch(getCatalogItem(productId));
    }
    if (itemStatus === 'succeeded') {
      setCurrentItem(catalogItem.items[0]);
      if (catalogItem.items[0].light == null || !catalogItem.items[0].light) {
        setLogoBGColor(darkBG);
      } else {
        setLogoBGColor(lightBG);
      }

      loadImages(catalogItem.items[0].productId);
      var currLogos = [];
      var addedLocs = [];
      var found = false;

      setCurrentSize(0);
    }
  }, [itemStatus, dispatch]);

  let content = "";
  let price = 0;

  if (itemStatus === 'loading') {
    content = <Spinner text="Loading..." />
  } else if (itemStatus === 'succeeded') {
    price = catalogItem.items[0].sizes[0].price;
    let sizes = new Array();

    let currItem = currentItem ? currentItem : catalogItem.items[0];

    for (var i = 0; i < currItem.sizes.length; i++) {
      var inv = inventory.find(item => item.uniqueKey == currItem.sizes[i].uniqueKey);
      console.log("INV", inv);
      if (inv && inv.quantity == 0) {
        sizes.push(<div><Button style={{ backgroundColor: currentSize === i ? "blue" : "" }} key={i} variant="secondary" data={i} disabled>{formatPantsSize(currItem.sizes[i].sizeName)}<br />{inv?.quantity}</Button></div>);

      } else {
        sizes.push(<div><Button style={{ backgroundColor: currentSize === i ? "blue" : "" }} key={i} variant="secondary" data={i} onClick={(event) => { sizeClick(event); }}>{formatPantsSize(currItem.sizes[i].sizeName)}<br />{inv?.quantity}</Button></div>);
      }
    }

    content = (
      <Container className="mt-5" style={{ marginBottom: "150px" }}>
        <Row>
          <Col sm={6}>
            <div style={{ display: "inline-block", position: "relative" }}>
              <img className="bg-image" src={imgSrc ? imgSrc : catalogItem.items[0].frontModelImage} width={'100%'}></img>
              {currentImage && currentImage.canHaveLogo && selectedLogos && selectedLogos.map((logo, i) => (
                <img className="logo-image" src={apiUrl + logo.imageUrl} width={logo.width + '%'} style={{ left: logo.x + '%', top: logo.y + '%', transform: 'rotate(' + logo.rotate + 'deg)' }}></img>
              )
              )}

            </div>
            {currentImage && currentImage.canHaveLogo &&
              <div style={{ fontSize: 11 }}>Please note that all items are custom created and decorated. We make every effort to ensure that images match the final product. All logos, locations, and colors are approximate and may not represent the final product based on decoration restrictions. We reserve the right to modify the images and decoration guidelines at any time and as necessary.</div>
            }
            <div className="small-image-container">
              {currentImages && currentImages.map((image, i) => (
                <img src={image.imageUrl} height={75} onClick={() => galleryImageClicked(image)}></img>
              ))}
            </div>
          </Col>
          <Col sm={6}>
            <div className="product-content">
              <div className="title">{catalogItem.items[0].title}</div>
              {catalogItem.items[0].htmlDescription && (
                <div className="description" dangerouslySetInnerHTML={{ __html: catalogItem.items[0].htmlDescription }} />
              )}
              {!catalogItem.items[0].htmlDescription && (
                <div className="description" dangerouslySetInnerHTML={{ __html: catalogItem.items[0].description }} />
              )}
              <div>
                {catalogItem.items[0].specSheet && (
                  catalogItem.items[0].specSheet.startsWith("http") ? (
                    <a target="_blank" href={`${catalogItem.items[0].specSheet}`}>Spec Sheet</a>
                  ) : (
                    <a target="_blank" href={`https://www.apparelvideos.com/images/specsheet/pdf/specsheet/${catalogItem.items[0].specSheet}`}>Spec Sheet</a>
                  )
                )
                }
                <br />
                {catalogItem.items[0].measurements && (
                  catalogItem.items[0].measurements.startsWith("http") ? (
                    <a target="_blank" href={`${catalogItem.items[0].measurements}`}>Measurements</a>
                  ) : (
                    <a target="_blank" href={`https://www.apparelvideos.com/images/specsheet/pdf/productmeasurements/${catalogItem.items[0].measurements}`}>Measurements</a>
                  )
                )}

              </div>

              {loginStatus ? (
                <div className="price">${(currentLogoPrice + catalogItem.items[0].price).toFixed(2)}</div>
              ) : null
              }

              <div className="color-title">
                Color: {currentColor ? currentColor : catalogItem.items[0].colorName}
              </div>
              <div className="colors">
                {catalogItem.items.map(item => (
                  <div className="color-swatch">
                    <img src={`https://cdnm.sanmar.com/swatch/gifs/${item.squareImageName}`} height={50}
                      onClick={(event) => colorImageClick(item)}

                    />
                  </div>
                ))}
              </div>
              <div className="color-title">
                Decorations Type:
              <div style={{ padding: 5, marginLeft: 20 }}>
                {logoType && logoType === "EMBR" ? "Embroidery" : null}
                {logoType && logoType === "VYNL" ? "Transfer" : null}
                {logoType && logoType === "SCRN" ? "Screen Print" : null}
              </div>

              </div>
              <div className="color-title">
                Decorations:
              </div>
              <div style={{ padding: 5, display: "flex", flexDirection: "row" }}>
                {logosByPosition && logosByPosition.map(logos => {
                  return logos.map(logo => (
                    <div onClick={() => decoClicked(logo)}>
                      <div style={{
                        margin: 4, width: "100px", height: "100px", backgroundColor: logoBGColor, borderStyle: "solid", borderWidth: "2px", borderColor: isSelecedLogo(logo) ? "blue" : "#CCCCCC", display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundImage: `url(${currentItem ? "https://cdnm.sanmar.com/swatch/gifs/" + currentItem.squareImageName : ""})`,
                        backgroundSize: "contain",
                      }}>
                        <img width="100%" src={apiUrl + logo.imageUrl} style={{padding: 4}} /><br />
                      </div>
                      <div style={{ marginLeft: 14 }}>{logo.locName}</div>
                    </div>
                  ))
                }
                )}
              </div>
              <div className="color-title">
                Sizes:
              </div>
              <div>
                <Container>
                  <Row>
                    {currentItem && currentItem.sizes && currentItem.sizes.map(size => {
                      var inv = inventory.find(item => item.uniqueKey == size.uniqueKey);
                      if (inv && inv.quantity == 0) {
                        return (
                          <Col lg="4">
                            <Button
                              style={{ height: 60, margin: 3, width: "100%", backgroundColor: currentSize === size.sizeId ? "blue" : "" }}
                              key={size.sizeId}
                              variant="secondary"
                              data={size.sizeId}
                              disabled>
                              {formatPantsSize(size.sizeName)}<br />OOS
                            </Button>
                          </Col>
                        );
                      } else {
                        if(inv && inv.quantity < 30) {
                          return (
                            <Col lg="4">
                              <Button style={{ height: 60, margin: 3, width: "100%", backgroundColor: currentSize === size.sizeId ? "blue" : "" }} key={size.sizeId} variant="secondary" data={size.sizeId} onClick={(event) => { sizeClick(size.sizeId); }}>{formatPantsSize(size.sizeName)}<br />Low Stock: {inv?.quantity}</Button>
                            </Col>
                          );
                         
                        } else {

                        return (
                          <Col lg="4">
                            <Button style={{ height: 60, margin: 3, width: "100%", backgroundColor: currentSize === size.sizeId ? "blue" : "" }} key={size.sizeId} variant="secondary" data={size.sizeId} onClick={(event) => { sizeClick(size.sizeId); }}>{formatPantsSize(size.sizeName)}</Button>
                          </Col>
                        );
                        }
                      }

                    })}
                  </Row>
                </Container>

              </div>
              <div className="quantity">
                {loginStatus ?
                  <Form.Select aria-label="Quantity" onChange={qtyChanged}>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                    <option value="6">6</option>
                    <option value="7">7</option>
                    <option value="8">8</option>
                    <option value="9">9</option>
                    <option value="10">10</option>
                  </Form.Select>
                  : null
                }
              </div>
              <div>
                {loginStatus ?
                  <Button onClick={addToCartButtonClicked}>Add to Cart</Button>
                  :
                  <Button onClick={gotoLogin}>Login or Register to add items to your cart</Button>
                }
              </div>
            </div>
          </Col>
        </Row>

      </Container>
    );

  } else if (itemStatus === 'failed') {
    content = <div>error</div>
  }

  return (
    <Container className="mt-5">
      {content}
    </Container>
  );
};
export default ProductDetails;
